import { axiosInstance } from '../../../shared/api';

export async function contactApi(userData) {
	try {
		const response = await axiosInstance.post('contact', userData);
		if (response.status === 200) {
			return response.data.message;
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}
